export enum PageType {
  LIST = "LIST",
  CREATE = "CREATE",
  EDIT = "EDIT",
  DETAIL = "DETAIL",
  HISTORY_LIST = "HISTORY_LIST",
  HISTORY_DETAIL = "HISTORY_DETAIL",
}

export enum TabTypes {
  OPEN = "OPEN",
  CLOSE = "CLOSE",
  CANCEL = "CANCEL",
  CREATED = "CREATED",
}

export enum JobFlowTypes {
  CREATOR = "CREATOR",
  APPROVER = "APPROVER",
  CHECKLIST = "CHECKLIST",
  EXECUTE = "EXECUTE",
}

export enum ApprovalModalType {
  APPROVE = "APPROVE",
  REJECT = "REJECT",
  DELETE = "DELETE",
  DETAIL_APPROVE = "DETAIL_APPROVE",
  DETAIL_REJECT = "DETAIL_REJECT",
}
